import { axiosBaseQuery } from "@api/base-services-axios-rtx";
import { createApi } from "@reduxjs/toolkit/query/react";

import { IValuesForgotPassword } from "@/public/auth/forgot-password/util/form.util";
import { IValuesLogin } from "@/public/auth/login/util/form.util";
import getFormData from "@/shared/helpers/get-form-data.helper";
import { LoginEndpoints } from "@/shared/models/endpoints/user-auth.endpoint";
import { IPayloadResetPassword } from "@/shared/models/interfaces/payloads/auth/reset-password.interface";
import { ILoginGoogleCallBackResponse } from "@/shared/models/interfaces/response/auth/login-google-callback.response";
import { ILoginResponse } from "@/shared/models/interfaces/response/auth/login-response.interface";
import { INormaResponse } from "@/shared/models/interfaces/response/normal-response.interface";

import { BaseValueModelQRTK } from "../../model/base-values.interface";
import UserAuthenticateAdapter from "./adapters/user-authenticate.adapter";
import { I_CurrentUserResponse } from "./model/responses/current-user";

export const AuthQueryServices = createApi({
  reducerPath: "Auth-services",
  baseQuery: axiosBaseQuery(),

  endpoints: builder => ({
    Login: builder.mutation({
      query: (body: IValuesLogin) => ({
        url: LoginEndpoints.LoggedUser,
        method: "POST",
        body: getFormData(body)
      }),
      transformResponse: (response: ILoginResponse, meta, arg) =>
        UserAuthenticateAdapter(response.data)
    }),

    getCurrentUser: builder.mutation({
      query: (values: BaseValueModelQRTK<any> | null) => ({
        url: LoginEndpoints.getCurrentUser,
        method: "GET"
      }),
      transformResponse: (response: I_CurrentUserResponse, meta, arg) =>
        response.data
    }),

    LoginGoogleCallback: builder.mutation({
      query: (search: string) => ({
        url: LoginEndpoints.LoggedUserGoogleCallback(search),
        method: "GET"
      }),
      transformResponse: (
        response: ILoginGoogleCallBackResponse,
        meta,
        arg
      ) => response.data
    }),

    forgotPassword: builder.mutation({
      query: (body: IValuesForgotPassword) => ({
        url: LoginEndpoints.forgotPasswordUser,
        method: "POST",
        body: getFormData(body)
      }),
      transformResponse: (response: INormaResponse, meta, arg) =>
        response.data
    }),

    resetPassword: builder.mutation({
      query: (values: IPayloadResetPassword) => {
        const { body, ...res } = values;
        return {
          url: LoginEndpoints.resetPasswordUser(res),
          method: "POST",
          body: getFormData(values.body)
        };
      },
      transformResponse: (response: INormaResponse, meta, arg) =>
        response.data
    }),

    LogoutUser: builder.mutation({
      query: (values: any = null) => ({
        url: LoginEndpoints.logoutUser,
        method: "POST"
      }),
      transformResponse: (response: INormaResponse, meta, arg) =>
        response.data
    })
  })
});


export const {
  useLoginMutation,
  useLoginGoogleCallbackMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useGetCurrentUserMutation,
  useLogoutUserMutation
} = AuthQueryServices;
